export default class SmoothScrollByQuery {
    constructor(
        queryParamName,
        targetElementSelector
    ) {
        this.queryParamName = queryParamName;
        this.targetElementSelector = targetElementSelector;
        this.initListeners();
    }

    initListeners() {
        const url = new URL(window.location.href);

        if (url.searchParams.has(this.queryParamName)) {
            const y = document.querySelector(this.targetElementSelector).getBoundingClientRect().top + window.scrollY;
            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        }
    }
}

